<div class="form-group">
  <wm-de-label
    [entity]="entity"
    [for]="entity.templateCode"
    [displayOnly]="true"
  ></wm-de-label>
  <input
    *ngFor="let i of listEntity.selectedTextValues"
    type="text"
    readonly
    class="form-control-plaintext"
    [id]="entity.templateCode"
    [value]="i.text"
    selected="i.text==value"
  />
</div>
